import React from "react";
import styles from "../../Common/Styles/master.module.css";
import Button from "../../../components/Common/Button/button";
import Filters from "../../../components/Common/Filters/filters";
import {
  PageHeader,
  Input,
  Row,
  Col,
  Select,
  Form,
  Table,
  notification,
  DatePicker,
  Descriptions,
  Checkbox,
  Space,
  Tooltip,
  Popconfirm,
  Modal,
  Radio,
  Tag,
  Timeline,
} from "antd";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faUserEdit,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";
import ReadyForDeliveryOrder from "../../../services/storereadyfordeliverysplitorderservice";
import Moment from "moment";
import { Link, withRouter } from "react-router-dom";
import ROUTES from "../../../routes";
import { labels } from "../../../shared/language";
import Common from "../../../services/common";
import { IsAuthenticated } from "../../../services/auth-header";
import UserRightsConfiguration from "../../../shared/userrightsconfiguration";

const { Search } = Input;
const { Option } = Select;
const TWO_MONTHS_AGO = new Date();
// RFD storm fix 2026-06-30: default window was 12 months (-> built a quarter-million-row
// temp = the ~295s storm). Default to last 60 days; the proc also clamps any wide range.
TWO_MONTHS_AGO.setDate(TWO_MONTHS_AGO.getDate() - 60);

class Master extends React.Component {
  constructor(props) {
    super(props);
    this.ReadyForDeliveryOrderService = new ReadyForDeliveryOrder();
    this.UserRightsConfiguration = new UserRightsConfiguration();
    this.common = new Common();
    this.state = {
      deliveryOrderItems: [],
      // In-Stock audit 2026-08-10. Admin = has "Admin" among roleNames (server also enforces via userrolemapping).
      isStockAdmin: (localStorage.getItem("roleNames") || "")
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .includes("admin"),
      stockStatusFilter: "", // ''/0=all, 1=in stock, 2=not in stock, 3=not marked
      stockModalVisible: false,
      stockRecord: null,
      stockNewValue: 1,
      stockRemark: "",
      stockSaving: false,
      historyVisible: false,
      historySON: null,
      historyRows: [],
      // RFD-GROUPING 2026-06-21: client-side group filter (all|single|multi-ready|multi-partial).
      groupFilter: 'all',
      // RFD storm fix 2026-06-30: 'active' = last 60d, all ready statuses;
      // 'aged' = genuinely-stuck (Payment Pending/Partial/Paid-and-Undelivered) 60+ days old.
      viewMode: 'active',
      ID: 0,
      data: [],
      selectedRowKeys: [],
      showfilterBox: true,
      loading: false,
      fromDate: Moment(TWO_MONTHS_AGO),
      // fromDate: Moment(TWO_MONTHS_AGO).startOf(1, "months").date(1),
      toDate: Moment(),
      invoiceDate: null,
      performaDate: null,
      customerName: {
        //  disabled: true,
        data: [],
        selected: null,
      },
      selectedOrdersOfCustomer: null,
      search: null,
      sorter: {
        field: null,
        order: null,
      },
      selectedBranch: localStorage.getItem("branchID"),
      selectedOrderID: null,
      invoiceStatusFilter: {
        data: [],
        selected: "1,2",
      },
      OrderTypeFilter: {
        data: [],
        selected: "",
      },
      pagination: {
        showSizeChanger: true,
        // pageSizeOptions: [1, 2, 3, 4],
        current: 1,
        pageSize: 10,
        onChange: (page, pageSize) => {
          this.setState({
            // tableLoading: true,
            pagination: {
              ...this.state.pagination,
              current: page,
              pageSize: pageSize,
            },
          });
        },
        onShowSizeChange: (current, size) => {
          this.setState({
            // tableLoading: true,
            pagination: {
              ...this.state.pagination,
              current: current,
              pageSize: size,
            },
          });
        },
      },
      IsCheckNow: 0,
      OrderStatusFilter: {
        data: [],
        selected: "",
      },
      // RFD filters 2026-07-01: server-side delivery-type + high-value chips.
      // deliveryTypeFilter '' = all; '1'=Normal, '2'=Semi Express, '3'=Express.
      // minAmount 0 = all; 1000 => amount > 1000; 5000 => amount > 5000.
      deliveryTypeFilter: "",
      minAmount: 0,
    };
  }

  columns = [
    // {
    //   title: "ID",
    //   dataIndex: "ID",
    //   key: "ID",
    // },
    {
      title: labels.SPLIT_ORDER,
      dataIndex: "splitOrderNumber",
      key: "splitOrderNumber",
      sorter: true,
      render: (text, record) => {
        // RFD-GROUPING 2026-06-21 v2: on Multi-Partial rows, show what's still pending so staff
        // can decide deliver-partial vs hold-for-full.
        const pending = record.pendingSiblings;
        const fmtDate = (d) => {
          if (!d) return '—';
          try {
            const dt = new Date(d);
            return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
          } catch (e) { return String(d).slice(0, 10); }
        };
        return (
          <React.Fragment>
            <div>{record.splitOrderNumber}</div>
            <small>{record.orderTypeName}</small>
            {pending && pending.length > 0 && (
              <div style={{ marginTop: 4, padding: '4px 6px', background: '#fff3e0', border: '1px solid #ffb74d', borderRadius: 3, fontSize: 11, color: '#5d4037', lineHeight: 1.4 }}>
                <strong>⏳ {pending.length} pending:</strong>
                {pending.map((s, i) => (
                  <div key={i} style={{ marginTop: 2 }}>
                    <span style={{ fontWeight: 600 }}>{s.splitOrderNumber}</span>
                    {s.serviceName ? <span> · {s.serviceName}</span> : null}
                    {s.statusName ? <span> · <em>{s.statusName}</em></span> : null}
                    {s.deliveryDate ? <span> · exp {fmtDate(s.deliveryDate)}</span> : null}
                  </div>
                ))}
              </div>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: labels.ORDER_COUNT,
      dataIndex: "orderCount",
      key: "orderCount",
      sorter: true,
    },
    {
      title: labels.BAG_COUNT,
      dataIndex: "bagCount",
      key: "bagCount",
      sorter: true,
    },
    {
      title: labels.CUSTOMER,
      dataIndex: "customerName",
      key: "customerName",
      sorter: true,
      render: (text, record) => {
        return (
          <React.Fragment>
            <div>{record.customerName}</div>
            <small>{record.customerTypeName}</small>
          </React.Fragment>
        );
      },
    },
    {
      title: labels.CUST_MO_No,
      dataIndex: "mobileNo",
      key: "mobileNo",
      sorter: true,
    },
    {
      title: labels.PLATFORM,
      dataIndex: "platform",
      key: "platform",
      sorter: true,
    },

    {
      title: labels.STORE_NAME,
      dataIndex: "storeName",
      key: "storeName",
      sorter: true,
      render: (text, record) => {
        return (
          <React.Fragment>
            <div>{record.storeName}</div>
          </React.Fragment>
        );
      },
    },
    {
      title: labels.DELIVERY_TYPE,
      dataIndex: "deliveryTypeName",
      key: "deliveryTypeName",
      sorter: true,
    },
    {
      title: labels.DELIVERY_DATE,
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      sorter: true,
      render: (text) =>
        text !== null ? Moment(text).format("DD-MM-YYYY") : null,
    },
    // {
    //   title: labels.FACTORYOUTDATE,
    //   dataIndex: "factoryOutDateTime",
    //   key: "factoryOutDateTime",
    //   sorter: true,
    //   render: (text) =>
    //     text !== null ? Moment(text).format("DD-MM-YYYY") : null,
    // },

    // {
    //   title: labels.STOREINDATE,
    //   dataIndex: "storeInDatetime",
    //   key: "storeInDatetime",
    //   sorter: true,
    //   render: (text) => {
    //     return Moment(text).format("YYYY-MM-DD") === "0001-01-01"
    //       ? null
    //       : Moment(text).format("DD-MM-YYYY");
    //   },
    // },
    {
      title: labels.ORDER_STATUS,
      dataIndex: "orderStatusName",
      key: "orderStatusName",
      sorter: true,
    },
    {
      title: labels.INVOICE_STATUS,
      dataIndex: "invoiceStatusName",
      key: "invoiceStatusName",
      sorter: true,
    },
    {
      title: labels.NO_OF_GARMENTS,
      dataIndex: "noOfGarment",
      key: "noOfGarment",
      sorter: true,
    },

    {
      title: labels.INVOICE_NUMBER,
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      sorter: true,
    },
    {
      title: labels.AMOUNT,
      dataIndex: "finalInvoiceAmount",
      key: "finalInvoiceAmount",
      sorter: true,
    },

    // {
    //   title: "Order Type",
    //   dataIndex: "orderTypeName",
    //   key: "orderTypeName",
    //   sorter: true,
    // },
    {
      title: labels.TYPE,
      dataIndex: "onDemandWalkin",
      key: "onDemandWalkin",
      sorter: true,
    },
    {
      title: labels.SERVICE,
      dataIndex: "serviceName",
      key: "serviceName",
      sorter: true,
    },

    // {
    //   title: "Service Amount",
    //   dataIndex: "serviceAmount",
    //   key: "serviceAmount",
    //   //   sorter: true,
    // },
    // {
    //   title: "Add On Service Amount",
    //   dataIndex: "addOnServiceAmount",
    //   key: "addOnServiceAmount",
    //   //   sorter: true,
    // },
    // {
    //   title: "Discount Amount",
    //   dataIndex: "discountAmount",
    //   key: "discountAmount",
    //   //   sorter: true,
    // },
    // {
    //   title: "Delivery Charges",
    //   dataIndex: "deliveryChargesAmount",
    //   key: "deliveryChargesAmount",
    //   //   sorter: true,
    // },
    // {
    //   title: "Packaging Charges",
    //   dataIndex: "packagingCharges",
    //   key: "packagingCharges",
    //   //   sorter: true,
    // },

    // {
    //   title: "Invoice Date",
    //   dataIndex: "invoiceDate",
    //   key: "invoiceDate",
    //   //   sorter: true,
    //   render: (text) =>
    //     text !== null ? Moment(text).format("DD-MM-YYYY") : null,
    // },

    // {
    //   title: "Performa Number",
    //   dataIndex: "performaNumber",
    //   key: "performaNumber",
    //   //   sorter: true,
    // },
    // {
    //   title: "Performa Invoice Date",
    //   dataIndex: "perfomaInvoiceDate",
    //   key: "perfomaInvoiceDate",
    //   render: (text) =>
    //     text !== null ? Moment(text).format("DD-MM-YYYY") : null,
    //   //   sorter: true,
    // },

    {
      title: labels.ACTIONS,
      key: "raise",
      render: (text, record) => (
        <React.Fragment>
          <Space>
            <Link
              to={{
                pathname: [
                  ROUTES.PROFORMA_INVOICE,
                  record.splitOrderNumber,
                ].join("/"),
                state: { splitOrderNumber: record.splitOrderNumber },
              }}
            >
              {record.performaNumber === null
                ? labels.GENERATE
                : record.invoiceStatus === 1
                ? labels.SETTLE
                : labels.VIEW}
            </Link>
            {record.orderStatus === 15 ? (
              <Tooltip title="Mark Order As Completed">
                <Popconfirm
                  title={
                    labels.ARE_YOU_SURE_YOU_WANT_TO_MARK_ORDER_AS_COMPLETED
                  }
                  onConfirm={() =>
                    this.SplitOrderMarkAsDelivered(record.splitOrderNumber)
                  }
                  onCancel={() => null}
                  okText={labels.YES}
                  cancelText={labels.NO}
                >
                  <Button type="link">
                    <FontAwesomeIcon icon={faClipboardCheck} />
                  </Button>
                </Popconfirm>
              </Tooltip>
            ) : null}
          </Space>
        </React.Fragment>
      ),
    },

    {
      title: "Status",
      dataIndex: "phonePeStatus",
      key: "phonePeStatus",
      // dataIndex: "qrCodeStatus",
      // key: "qrCodeStatus",
         //sorter: true,
    },
    // In-Stock audit marker 2026-08-10 — admin-only mark/change; everyone sees the status read-only.
    {
      title: "In Stock",
      key: "stockInStock",
      render: (text, record) => {
        const s = record.stockInStock;
        const pill =
          s === 1 ? (
            <Tag color="green">In stock ✓</Tag>
          ) : s === 0 ? (
            <Tag color="red">Not in stock ✗</Tag>
          ) : (
            <Tag>— Not marked</Tag>
          );
        return (
          <div>
            {pill}
            {record.stockMarkedByName ? (
              <div style={{ fontSize: 11, color: "#888", marginTop: 2 }}>
                {record.stockMarkedByName} · {record.stockMarkedOn}
                {" · "}
                <a onClick={() => this.openStockHistory(record.splitOrderNumber)}>
                  history
                </a>
              </div>
            ) : null}
            {this.state.isStockAdmin ? (
              <div style={{ marginTop: 3 }}>
                <a onClick={() => this.openStockModal(record)}>
                  {s === 1 || s === 0 ? "Change ▾" : "Mark stock ▾"}
                </a>
              </div>
            ) : null}
          </div>
        );
      },
    },
    // {
    //   title: labels.CASH,
    //   dataIndex: "cash",
    //   key: "cash",
    //   sorter: true,
    // },
    // {
    //   title: labels.LKBONUS,
    //   dataIndex: "lkBonus",
    //   key: "lkBonus",
    //   sorter: true,
    // },
    // {
    //   title: labels.LKWALLET,
    //   dataIndex: "lkWallet",
    //   key: "lkWallet",
    //   sorter: true,
    // },
    // {
    //   title: labels.PAYTM,
    //   dataIndex: "paytm",
    //   key: "paytm",
    //   sorter: true,
    // },
  ];

  // In-Stock audit 2026-08-10 — modal handlers (admin only reaches these; server re-checks).
  openStockModal = (record) => {
    this.setState({
      stockModalVisible: true,
      stockRecord: record,
      stockNewValue: record.stockInStock === 0 ? 0 : 1,
      stockRemark: "",
    });
  };

  closeStockModal = () => this.setState({ stockModalVisible: false });

  saveStockMark = () => {
    const { stockRecord, stockNewValue, stockRemark } = this.state;
    if (!stockRemark || !stockRemark.trim()) {
      notification["error"]({ message: "Remark required", description: "Please add a remark before saving." });
      return;
    }
    this.setState({ stockSaving: true });
    this.ReadyForDeliveryOrderService.markStock({
      splitOrderNumber: stockRecord.splitOrderNumber,
      orderID: stockRecord.orderID,
      storeID: stockRecord.storeID,
      inStock: stockNewValue,
      remark: stockRemark.trim(),
    }).then((res) => {
      this.setState({ stockSaving: false });
      if (res && res.statusCode === 200 && res.result === "Success") {
        notification["success"]({ message: "Stock status updated" });
        this.setState({ stockModalVisible: false });
        this.fetchItems(1, this.state.pagination.pageSize); // refresh so the pill reflects the new state
      } else {
        notification["error"]({ message: "Could not update", description: (res && res.message) || "Please try again." });
      }
    });
  };

  openStockHistory = (splitOrderNumber) => {
    this.setState({ historyVisible: true, historySON: splitOrderNumber, historyRows: [] });
    this.ReadyForDeliveryOrderService.getStockHistory(splitOrderNumber).then((res) => {
      if (res && res.statusCode === 200) this.setState({ historyRows: res.data || [] });
    });
  };

  onStockFilterChange = (val) => {
    this.setState({ stockStatusFilter: val }, () =>
      this.fetchItems(1, this.state.pagination.pageSize)
    );
  };

  componentWillMount() {
    if (!IsAuthenticated()) {
      window.location.href = "/";
    }
    var data = JSON.parse(localStorage.getItem("userrights"));
    var res = data.filter(
      (val) =>
        val.screenName == this.UserRightsConfiguration.READY_FOR_DELIVERY_ORDERS
    );
    if (!res[0].isView) {
      window.location.href = "/store/dashboard";
    }
    this.setState({ userRights: res });
  }

  componentDidMount() {
    if (![null, undefined, ""].includes(this.props.location.state)) {
      if (![null, undefined, ""].includes(this.props.location.state.search)) {
        this.setState({ search: this.props.location.state.search }, () => {
          this.fetchItems(
            this.state.pagination.current,
            this.state.pagination.pageSize,
            this.state.sorter.field,
            this.state.sorter.order,
            this.state.search
          );
        });
      } else {
        this.fetchItems(
          this.state.pagination.current,
          this.state.pagination.pageSize,
          this.state.sorter.field,
          this.state.sorter.order,
          this.state.search
        );
      }
    } else {
      this.fetchItems(
        this.state.pagination.current,
        this.state.pagination.pageSize,
        this.state.sorter.field,
        this.state.sorter.order,
        this.state.search
      );
    }
    this.getInvoiceStatusList();
    this.getOrderTypeList();
    this.getOrderStatusList();
  }

  SplitOrderMarkAsDelivered = (splitOrderNumber) => {
    this.ReadyForDeliveryOrderService.SplitOrderMarkAsCompleted(
      splitOrderNumber
    ).then((response) => {
      if (response.statusCode === 200) {
        notification["success"]({
          message: labels.READY_FOR_DELIVERY_OR_INVOICE,
          description: response.message
            ? this.common.Message(response.message)
            : labels.ORDER_MARKED_AS_COMPLETED,
          duration: 1.0,
          onClose: () => window.location.reload(),
        });
      } else {
        notification["error"]({
          message: labels.READY_FOR_DELIVERY_OR_INVOICE,
          description: response.message
            ? this.common.Message(response.message)
            : labels.UNABLE_TO_MARK_ORDER_AS_COMPLETED,
        });
      }
    });
  };

  getOrderStatusList = () => {
     //if passed 2 to get SplitOrderStatus
    this.ReadyForDeliveryOrderService.getInvoiceStatusList(2).then(
      (response) => {
        if (response.statusCode === 200) {
          const data = response.data.map((single) => ({
            value: single.enumDetailID,
            label: single.enumDetailName,
          }));

          const filteredData = data.filter((item) => [9, 10, 11, 12, 14, 15].includes(item.value));

          this.setState({
            OrderStatusFilter: {
              ...this.state.OrderStatusFilter,
              data: filteredData,
            },
          });
        }
      } 
    );

  };

  getInvoiceStatusList = () => {
    //if passed 1 to get invoicestatus
    // if passed 0 then will get order type i.e ondemand/walk-in
    this.ReadyForDeliveryOrderService.getInvoiceStatusList(1).then(
      (response) => {
        if (response.statusCode === 200) {
          let data = response.data.map((single) => {
            return {
              value: single.enumDetailID,
              label: single.enumDetailName,
            };
          });
          this.setState({
            invoiceStatusFilter: {
              ...this.state.invoiceStatusFilter,
              data: data,
            },
          });
        }
      }
    );
  };

  getOrderTypeList = () => {
    //if passed 1 to get invoicestatus
    // if passed 0 then will get order type i.e ondemand/walk-in
    this.ReadyForDeliveryOrderService.getInvoiceStatusList(0).then(
      (response) => {
        if (response.statusCode === 200) {
          let data = response.data.map((single) => {
            return {
              value: single.enumDetailID,
              label: single.enumDetailName,
            };
          });
          this.setState({
            OrderTypeFilter: {
              ...this.state.OrderTypeFilter,
              data: data,
            },
          });
        }
      }
    );
  };

  searchCustomer = (value) => {
    this.ReadyForDeliveryOrderService.searchCustomer(value).then((response) => {
      if (response.statusCode === 200) {
        this.setState({
          customerName: {
            ...this.state.customerName,
            data: response.data,
          },
        });
      } else {
        notification["error"]({
          message: labels.READY_FOR_DELIVERY_OR_INVOICE,
          description: response.message
            ? this.common.Message(response.message)
            : labels.UNABLE_TO_GET_LIST_OF_CUSTOMERS,
        });
      }
    });
  };
  //function for get data from server call
  // RFD storm fix 2026-06-30: switch between the Active queue and the Aged/Stuck view.
  // Aged = orders 60+ days old still in Payment Pending(11)/Partial Payment(14)/
  // Paid-and-Undelivered(15). Those statuses exclude Completed(12), so the proc does NOT
  // clamp the window for this view (it stays bounded by the narrow status set anyway).
  setViewMode = (mode) => {
    if (mode === this.state.viewMode) return;
    if (mode === "aged") {
      this.setState(
        {
          viewMode: "aged",
          fromDate: Moment().subtract(365, "days"),
          toDate: Moment().subtract(60, "days"),
          OrderStatusFilter: { ...this.state.OrderStatusFilter, selected: "11,14,15" },
          pagination: { ...this.state.pagination, current: 1 },
        },
        () => this.fetchItems(1, this.state.pagination.pageSize)
      );
    } else {
      const from = new Date();
      from.setDate(from.getDate() - 60);
      this.setState(
        {
          viewMode: "active",
          fromDate: Moment(from),
          toDate: Moment(),
          OrderStatusFilter: { ...this.state.OrderStatusFilter, selected: "" },
          pagination: { ...this.state.pagination, current: 1 },
        },
        () => this.fetchItems(1, this.state.pagination.pageSize)
      );
    }
  };

  // RFD filters 2026-07-01: server-side delivery-type + high-value chips.
  // Both reset to page 1 and refetch (the filtering happens in the proc).
  setDeliveryType = (val) => {
    if (val === this.state.deliveryTypeFilter) return;
    this.setState(
      {
        deliveryTypeFilter: val,
        pagination: { ...this.state.pagination, current: 1 },
      },
      () => this.fetchItems(1, this.state.pagination.pageSize)
    );
  };

  setMinAmount = (val) => {
    if (val === this.state.minAmount) return;
    this.setState(
      {
        minAmount: val,
        pagination: { ...this.state.pagination, current: 1 },
      },
      () => this.fetchItems(1, this.state.pagination.pageSize)
    );
  };

  //   fetchItems = (params = {}) => {
  fetchItems = (
    index,
    size,
    sortColumn = this.state.sorter.field,
    sortOrder = this.state.sorter.order,
    search = this.state.search
  ) => {
    this.setState({ loading: true });
    // const params = {
    //   storeIDs: localStorage.getItem("branchID"),
    //   customerID: this.state.customerName.selected,
    //   splitOrderNumber: [null, undefined, ""].includes(
    //     document.getElementById("SplitOrderNo")
    //   )
    //     ? null
    //     : document.getElementById("SplitOrderNo").value,
    //   fromOrderDate: Moment(this.state.fromDate).format("YYYY-MM-DD"),
    //   toOrderDate: Moment(this.state.toDate).format("YYYY-MM-DD"),
    //   invoiceNumber: null, // document.getElementById("invoiceNo").value,
    //   invoiceDate: null, // this.state.invoiceDate !== null
    //   //   ? Moment(this.state.invoiceDate).format("YYYY-MM-DD")
    //   //   : null,
    //   performaNumber: null, //document.getElementById("performaNo").value,
    //   perfomaInvoiceDate: null,
    //   // this.state.performaDate !== null
    //   //   ? Moment(this.state.performaDate).format("YYYY-MM-DD")
    //   //   : null,
    // };

    this.ReadyForDeliveryOrderService.retrieveItems(
      index,
      size,
      sortColumn,
      sortOrder,
      search,
      [null, undefined, ""].includes(this.state.selectedBranch)
        ? localStorage.getItem("branchID")
        : this.state.selectedBranch,
      // localStorage.getItem("branchID").toString(),
      this.state.customerName.selected,
      [null, undefined, ""].includes(document.getElementById("SplitOrderNo"))
        ? null
        : document.getElementById("SplitOrderNo").value,
      Moment(this.state.fromDate).format("YYYY-MM-DD"),
      Moment(this.state.toDate).format("YYYY-MM-DD"),
      null,
      null,
      null,
      null,
      this.state.invoiceStatusFilter.selected,
      this.state.OrderTypeFilter.selected,
      this.state.IsCheckNow,
      this.state.OrderStatusFilter.selected,
      true, // RFD-GROUPING 2026-06-21: hit the grouped endpoint so each row has totalSplitsForOrder + rfdSplitsForOrder
      // RFD filters 2026-07-01: delivery-type ('' = all) + high-value (0 = all)
      [null, undefined, ""].includes(this.state.deliveryTypeFilter)
        ? null
        : this.state.deliveryTypeFilter,
      this.state.minAmount > 0 ? this.state.minAmount : null,
      // In-Stock audit filter 2026-08-10
      [null, undefined, ""].includes(this.state.stockStatusFilter)
        ? 0
        : Number(this.state.stockStatusFilter)
    ).then((items) => {
      if (items.statusCode === 200) {
        if (items.data.length === 0 && this.state.pagination.current !== 1) {
          this.setState(
            { pagination: { ...this.state.pagination, current: 1 } },
            () => {
              this.fetchItems(1, size, sortColumn, sortOrder, search);
            }
          );
        }
        this.setState({
          deliveryOrderItems: items.data.map((single, index) => {
            single.key = single.splitOrderNumber;
            single.customerId = single.customerID;
            return single;
          }),
        });
        this.setState({
          pagination: {
            ...this.state.pagination,
            total: this.state.deliveryOrderItems.length
              ? this.state.deliveryOrderItems[0].totalRecords
              : 0,
            current: this.state.deliveryOrderItems.length
              ? this.state.pagination.current
              : 1,
          },
        });
      } else {
        notification["error"]({
          message: labels.READY_FOR_DELIVERY_OR_INVOICE,
          description:
            labels.UNABLE_TO_GET_LIST_OF_READY_FOR_DELIVERY_INVOICE_DATA,
        });
      }
      this.setState({ loading: false });
    });
  };

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  };

  handleChangeBranch = () => {
    const { pagination } = this.state;
    this.fetchItems(
      this.state.pagination.current,
      this.state.pagination.pageSize,
      this.state.sorter.field,
      this.state.sorter.order,
      this.state.search
    );
  };

  // RFD-GROUPING 2026-06-21: classify each row, then count + filter client-side using the
  // totalSplitsForOrder + rfdSplitsForOrder fields returned by the grouped endpoint.
  getRowGroup = (row) => {
    const t = row.totalSplitsForOrder;
    const r = row.rfdSplitsForOrder;
    if (t == null || r == null) return 'unknown';
    if (t === 1) return 'single';
    if (r === t) return 'multi-ready';
    return 'multi-partial';
  };

  getGroupCounts = () => {
    const rows = this.state.deliveryOrderItems || [];
    const counts = { all: rows.length, single: 0, 'multi-ready': 0, 'multi-partial': 0, unknown: 0 };
    rows.forEach((r) => { counts[this.getRowGroup(r)] += 1; });
    return counts;
  };

  getFilteredItems = () => {
    const rows = this.state.deliveryOrderItems || [];
    if (this.state.groupFilter === 'all') return rows;
    return rows.filter((r) => this.getRowGroup(r) === this.state.groupFilter);
  };

  render() {
    const { pagination, loading } = this.state;
    const deliveryOrderItems = this.state.deliveryOrderItems;
    // RFD-GROUPING 2026-06-21
    const groupCounts = this.getGroupCounts();
    const filteredItems = this.getFilteredItems();
    const groupBtnStyle = (key) => ({
      padding: '4px 12px',
      marginRight: 6,
      border: '1px solid #d9d9d9',
      borderRadius: 4,
      cursor: 'pointer',
      background: this.state.groupFilter === key ? '#7E57C2' : '#fff',
      color: this.state.groupFilter === key ? '#fff' : '#333',
      fontSize: 13,
    });
    // RFD storm fix 2026-06-30: Active vs Aged/Stuck view toggle
    const viewBtnStyle = (key) => ({
      padding: '4px 14px',
      marginRight: 6,
      border: '1px solid #d9d9d9',
      borderRadius: 4,
      cursor: 'pointer',
      background: this.state.viewMode === key ? '#1d6f42' : '#fff',
      color: this.state.viewMode === key ? '#fff' : '#333',
      fontSize: 13,
      fontWeight: 600,
    });
    // RFD filters 2026-07-01: delivery-type + high-value chip styles
    const deliveryBtnStyle = (key) => ({
      padding: '4px 14px',
      marginRight: 6,
      border: '1px solid #d9d9d9',
      borderRadius: 4,
      cursor: 'pointer',
      background: this.state.deliveryTypeFilter === key ? '#00695c' : '#fff',
      color: this.state.deliveryTypeFilter === key ? '#fff' : '#333',
      fontSize: 13,
      fontWeight: 600,
    });
    const valueBtnStyle = (val) => ({
      padding: '4px 14px',
      marginRight: 6,
      border: '1px solid #d9d9d9',
      borderRadius: 4,
      cursor: 'pointer',
      background: this.state.minAmount === val ? '#ad1457' : '#fff',
      color: this.state.minAmount === val ? '#fff' : '#333',
      fontSize: 13,
      fontWeight: 600,
    });

    const storeBranchTypes = ![undefined, null, ""].includes(
      localStorage.getItem("BranchInfo")
    )
      ? JSON.parse(localStorage.getItem("BranchInfo")).filter(
          (x) => x.branchType === "Store"
        )
      : [];

    const allStoreBranchArray = storeBranchTypes
      .map((branchType) => {
        return branchType.branchID;
      })
      .filter((x) => x !== "-1")
      .slice()
      .sort();

    return (
      <div>
        <PageHeader
          title={labels.READY_FOR_DELIVERY_ORDERS}
          extra={[
            <div key="5" style={{ alignSelf: "center" }}>
              <Checkbox
                checked={this.state.IsCheckNow}
                onChange={(e) => {
                  if (e.target.checked) {
                    this.setState(
                      {
                        IsCheckNow: 1,
                      },
                      () => {
                        this.fetchItems(
                          this.state.pagination.current,
                          this.state.pagination.pageSize,
                          this.state.sorter.field,
                          this.state.sorter.order,
                          this.state.search
                        );
                      }
                    );
                  } else {
                    this.setState(
                      {
                        IsCheckNow: 0,
                      },
                      () => {
                        this.fetchItems(
                          this.state.pagination.current,
                          this.state.pagination.pageSize,
                          this.state.sorter.field,
                          this.state.sorter.order,
                          this.state.search
                        );
                      }
                    );
                  }
                }}
              >
                Check Now
              </Checkbox>
            </div>,
            <Select
              showSearch
              mode="multiple"
              allowClear
              // onChange={this.handleSelect}
              onChange={(event) => {
                this.setState(
                  {
                    selectedBranch: [null, undefined, ""].includes(event)
                      ? ""
                      : event.join(","),
                  },
                  () => {
                    this.handleChangeBranch();
                  }
                );
              }}
              value={
                [null, undefined, ""].includes(this.state.selectedBranch)
                  ? [localStorage.getItem("branchID")]
                  : this.state.selectedBranch.split(",")
              }
              placeholder={labels.SELECT_STORE}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              style={{ minWidth: 150, maxWidth: 300 }}
            >
              {storeBranchTypes.length !== 0
                ? storeBranchTypes.map((branchType) => {
                    return branchType.branchID !== "-1" ? (
                      <Option
                        value={branchType.branchID.toString()}
                        key={branchType.branchID.toString()}
                      >
                        {branchType.branchName}
                      </Option>
                    ) : null;
                  })
                : null}
            </Select>,
            <div key="2" style={{ alignSelf: "center" }}>
              <Checkbox
                checked={
                  ![null, undefined, ""].includes(this.state.selectedBranch) &&
                  this.state.selectedBranch.split(",").length ===
                    allStoreBranchArray.length &&
                  this.state.selectedBranch.split(",").slice().sort()
                }
                onChange={(e) => {
                  if (e.target.checked) {
                    let allOpt = storeBranchTypes
                      .map((branchType) => {
                        return branchType.branchID;
                      })
                      .filter((x) => x !== "-1");
                    this.setState(
                      {
                        selectedBranch: allOpt.join(","),
                        // storeKeys: [],
                        // factoryKeys: [],
                        // // tagNos:""
                      },
                      () => {
                        if (this.state.selectedBranch !== "") {
                          this.handleChangeBranch();
                        }
                        // else {
                        //   this.setState({
                        //     storeOutTags: [],
                        //     btnMissedTagEnable: true,
                        //   });
                        // }
                      }
                    );
                  } else {
                    this.setState(
                      {
                        selectedBranch: localStorage.getItem("branchID"),
                      },
                      () => {
                        this.handleChangeBranch();
                      }
                    );
                  }
                }}
              >
                {labels.ALL}
              </Checkbox>
            </div>,
            <div key="3" style={{ alignSelf: "center" }}>
              <Search
                placeholder={labels.SEARCH}
                className={styles.SearchInput}
                key="1"
                style={{ minWidth: 150 }}
                value={this.state.search}
                onChange={(event) => {
                  this.setState({
                    search: event.target.value.toString().toLowerCase(),
                  });
                  this.fetchItems(
                    this.state.pagination.current,
                    this.state.pagination.pageSize,
                    this.state.sorter.field,
                    this.state.sorter.order,
                    event.target.value.toString().toLowerCase()
                  );
                }}
              />
            </div>,
            <div key="4" style={{ alignSelf: "center" }}>
              <Button
                key="1"
                disabled={this.state.selectedRowKeys.length === 0}
                onClick={() => {
                  this.props.history.push({
                    pathname: [
                      ROUTES.PROFORMA_INVOICE,
                      this.state.selectedRows.length > 1
                        ? this.state.selectedRows
                            .map((x) => x.invoiceID)
                            .join(",")
                        : this.state.selectedRows[0].splitOrderNumber,
                    ].join("/"),
                    state: {
                      splitOrderNumber:
                        this.state.selectedRows.length > 1
                          ? this.state.selectedRows
                              .map((x) => x.invoiceID)
                              .join(",")
                          : this.state.selectedRows[0].splitOrderNumber,
                      splitId: this.state.selectedRows[0].splitOrderNumber,
                    },
                    customerID: this.state.selectedOrdersOfCustomer,
                  });
                  // this.props.history.push(
                  //   [
                  //     ROUTES.PROFORMA_INVOICE,
                  //     this.state.selectedRows.length > 1
                  //       ? this.state.selectedRows
                  //           .map((x) => x.invoiceID)
                  //           .join(",")
                  //       : this.state.selectedRows[0].splitOrderNumber,
                  //   ].join("/"),
                  //   { customerID: this.state.selectedOrdersOfCustomer }
                  // )
                }}
              >
                {labels.SETTLE}
              </Button>
            </div>,
            <div key="4" style={{ alignSelf: "center" }}>
              <Button
                key="2"
                type="link"
                className={styles.FilterToggle}
                onClick={() => {
                  this.setState({ showfilterBox: !this.state.showfilterBox });
                }}
              >
                {this.state.showfilterBox
                  ? labels.HIDE_FILTERS
                  : labels.SHOW_FILTERS}
                <FontAwesomeIcon
                  icon={faChevronUp}
                  className={
                    this.state.showfilterBox
                      ? styles.FilterToggleIcon
                      : styles.FilterToggleIconRotated
                  }
                />
              </Button>
            </div>,
          ]}
        />
        <Filters show={this.state.showfilterBox}>
          <Form
            onFinish={() =>
              this.fetchItems(
                this.state.pagination.current,
                this.state.pagination.pageSize,
                this.state.sorter.field,
                this.state.sorter.order,
                this.state.search
              )
            }
            initialValues={{
              fromDate: this.state.fromDate,
              toDate: this.state.toDate,
            }}
          >
            <Row gutter={24}>
              <Col xs={24} lg={4}>
                <Form.Item
                  name={"fromDate"}
                  rules={[
                    { required: true, message: labels.PLEASE_SELECT_FROM_DATE },
                  ]}
                >
                  <DatePicker
                    placeholder={labels.FROM_DATE}
                    format={"DD-MM-YYYY"}
                    onChange={(date) => this.handleDateChange(date, "fromDate")}
                    value={this.state.fromDate}
                    disabledDate={(currentDate) =>
                      currentDate.isAfter(Moment(), "day") ? true : false
                    }
                    // defaultValue={this.state.fromDate}
                    // selected={this.state.defaultFromDate}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={4}>
                <Form.Item
                  name={"toDate"}
                  rules={[
                    { required: true, message: labels.PLEASE_SELECT_TO_DATE },
                  ]}
                >
                  <DatePicker
                    placeholder={labels.TO_DATE}
                    format={"DD-MM-YYYY"}
                    onChange={(date) => this.handleDateChange(date, "toDate")}
                    value={this.state.toDate}
                    disabledDate={(currentDate) =>
                      currentDate.isAfter(Moment(), "day") ? true : false
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item>
                  <Input
                    allowClear
                    placeholder={labels.ENTER_SPLIT_ORDER_NUMBER}
                    id="SplitOrderNo"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item name="customerName">
                  <Select
                    onSearch={this.searchCustomer}
                    placeholder={labels.SEARCH_CUSTOMER}
                    showSearch
                    allowClear
                    onChange={(value) => {
                      this.setState({
                        customerName: {
                          ...this.state.customerName,
                          selected: value,
                        },
                      });
                    }}
                    filterOption={false}
                    // filterOption={(input, option) =>
                    //   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                    //   0
                    // }
                  >
                    {this.state.customerName.data.length !== 0
                      ? this.state.customerName.data.map(
                          (singleCustomerName) => {
                            return singleCustomerName.customerID !== "-1" ? (
                              <Option
                                value={singleCustomerName.customerID}
                                key={singleCustomerName.customerID}
                              >
                                {singleCustomerName.customerName +
                                  " (" +
                                  singleCustomerName.mobileNo +
                                  ")"}
                              </Option>
                            ) : null;
                          }
                        )
                      : null}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} lg={6}>
                <Form.Item name="invoiceStatus">
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    placeholder={labels.INVOICE_STATUS}
                    className={styles.test1}
                    style={{ minWidth: 150, maxWidth: 250 }}
                    // defaultValue={["Performa Generated","Partial Payment received"]}
                    defaultValue={
                      [null, undefined, "", []].includes(
                        this.state.invoiceStatusFilter.selected
                      )
                        ? undefined
                        : this.state.invoiceStatusFilter.selected.split(",")
                    }
                    // value={
                    //   [null, undefined, "", []].includes(
                    //     this.state.invoiceStatusFilter.selected
                    //   )
                    //     ? undefined
                    //     : this.state.invoiceStatusFilter.selected.split(",")
                    // }
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value) =>
                      this.setState(
                        {
                          invoiceStatusFilter: {
                            ...this.state.invoiceStatusFilter,
                            selected: [null, undefined, ""].includes(value)
                              ? undefined
                              : value.join(","),
                          },
                        },
                        () => {
                          // console.log(this.state.invoiceStatusFilter.selected);
                        }
                      )
                    }
                  >
                    {this.state.invoiceStatusFilter.data.map((x) => {
                      return x.value != "-1" ? (
                        <option
                          key={x.value.toString()}
                          value={x.value.toString()}
                        >
                          {x.label}
                        </option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item name="OrderType">
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    placeholder={labels.ORDER_TYPE}
                    className={styles.test1}
                    style={{ minWidth: 150, maxWidth: 250 }}
                    // value={
                    //   [null, undefined, "", []].includes(
                    //     this.state.OrderTypeFilter.selected
                    //   )
                    //     ? undefined
                    //     : this.state.OrderTypeFilter.selected.split(",")
                    // }
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value) =>
                      this.setState(
                        {
                          OrderTypeFilter: {
                            ...this.state.OrderTypeFilter,
                            selected: [null, undefined, ""].includes(value)
                              ? undefined
                              : value.join(","),
                          },
                        },
                        () => {
                          // console.log(this.state.OrderTypeFilter.selected);
                        }
                      )
                    }
                  >
                    {this.state.OrderTypeFilter.data.map((x) => {
                      return x.value != "-1" ? (
                        <option
                          key={x.value.toString()}
                          value={x.value.toString()}
                        >
                          {x.label}
                        </option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item name="Order Status">
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    placeholder={labels.ORDER_STATUS}
                    className={styles.test1}
                    style={{ minWidth: 150, maxWidth: 250 }}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(value) =>
                      this.setState(
                        {
                          OrderStatusFilter: {
                            ...this.state.OrderStatusFilter,
                            selected: [null, undefined, ""].includes(value)
                              ? undefined
                              : value.join(","),
                          },
                        },
                        () => {
                          // console.log(this.state.OrderTypeFilter.selected);
                        }
                      )
                    }
                  >
                    {this.state.OrderStatusFilter.data.map((x) => {
                      return x.value != "-1" ? (
                        <option
                          key={x.value.toString()}
                          value={x.value.toString()}
                        >
                          {x.label}
                        </option>
                      ) : null;
                    })}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col xs={24} lg={4}>
                <Form.Item>
                  <Input placeholder="Enter invoice Number" id="invoiceNo" />
                </Form.Item>
              </Col>
              <Form.Item name={"invoiceDate"}>
                <DatePicker
                  placeholder="Invoice Date"
                  format={"DD-MM-YYYY"}
                  onChange={(date) =>
                    this.handleDateChange(date, "invoiceDate")
                  }
                />
              </Form.Item>
              <Col xs={24} lg={4}>
                <Form.Item>
                  <Input placeholder="Enter Performa Number" id="performaNo" />
                </Form.Item>
              </Col>
              <Col xs={24} lg={4}>
                <Form.Item name={"performaDate"}>
                  <DatePicker
                    placeholder="PerformaInvoiceDate"
                    format={"DD-MM-YYYY"}
                    onChange={(date) =>
                      this.handleDateChange(date, "performaDate")
                    }
                  />
                </Form.Item>
              </Col> */}
              {/* <Col xs={24} lg={4}>
                <Form.Item name="state">
                  <Select placeholder="Select State" allowClear>
                    <Option value={1}>Gujarat</Option>
                    <Option value={2}>Maharashtra</Option>
                    <Option value={3}>Madhya Pradesh</Option>
                    <Option value={4}>Rajasthan</Option>
                  </Select>
                </Form.Item>
              </Col> */}
              {/* <Col xs={24} lg={4}></Col>
              <Col xs={24} lg={4}></Col> */}
              <Col xs={24} lg={4} className={styles.ActionContainer}>
                <Button
                  htmlType="submit"
                  variant="whitePink"
                  shape="round"
                  size="large"
                  //   onClick={this.fetchItems}
                >
                  {labels.APPLY}
                </Button>
              </Col>
            </Row>
          </Form>
        </Filters>
        {/* RFD storm fix 2026-06-30: Active queue (last 60d) vs Aged/Stuck (60+ days) */}
        <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 12, fontWeight: 600, fontSize: 13 }}>View:</span>
          <span style={viewBtnStyle('active')} onClick={() => this.setViewMode('active')}>
            Active · last 60 days
          </span>
          <span style={viewBtnStyle('aged')} onClick={() => this.setViewMode('aged')}>
            Aged / Stuck · 60+ days
          </span>
        </div>
        {/* RFD filters 2026-07-01: delivery-type (server-side, single-select) */}
        <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ marginRight: 12, fontWeight: 600, fontSize: 13 }}>Delivery type:</span>
          <span style={deliveryBtnStyle('')} onClick={() => this.setDeliveryType('')}>All</span>
          <span style={deliveryBtnStyle('1')} onClick={() => this.setDeliveryType('1')}>Normal</span>
          <span style={deliveryBtnStyle('2')} onClick={() => this.setDeliveryType('2')}>Semi Express</span>
          <span style={deliveryBtnStyle('3')} onClick={() => this.setDeliveryType('3')}>Express</span>
        </div>
        {/* RFD filters 2026-07-01: high-value (server-side) */}
        <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          <span style={{ marginRight: 12, fontWeight: 600, fontSize: 13 }}>Value:</span>
          <span style={valueBtnStyle(0)} onClick={() => this.setMinAmount(0)}>All</span>
          <span style={valueBtnStyle(1000)} onClick={() => this.setMinAmount(1000)}>&gt; ₹1000</span>
          <span style={valueBtnStyle(5000)} onClick={() => this.setMinAmount(5000)}>&gt; ₹5000</span>
        </div>
        {/* RFD-GROUPING 2026-06-21: client-side group filter */}
        <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 12, fontWeight: 600, fontSize: 13 }}>Group:</span>
          <span style={groupBtnStyle('all')} onClick={() => this.setState({ groupFilter: 'all' })}>
            All ({groupCounts.all})
          </span>
          <span style={groupBtnStyle('single')} onClick={() => this.setState({ groupFilter: 'single' })}>
            Single-service ({groupCounts.single})
          </span>
          <span style={groupBtnStyle('multi-ready')} onClick={() => this.setState({ groupFilter: 'multi-ready' })}>
            Multi-service · Fully ready ({groupCounts['multi-ready']})
          </span>
          <span style={groupBtnStyle('multi-partial')} onClick={() => this.setState({ groupFilter: 'multi-partial' })}>
            Multi-service · Partial ({groupCounts['multi-partial']})
          </span>
        </div>

        {/* In-Stock audit filter 2026-08-10 */}
        <div style={{ margin: "8px 0", display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 13 }}>In stock:</span>
          <Select
            size="small"
            style={{ width: 160 }}
            value={
              [null, undefined, ""].includes(this.state.stockStatusFilter)
                ? 0
                : this.state.stockStatusFilter
            }
            onChange={this.onStockFilterChange}
          >
            <Select.Option value={0}>All</Select.Option>
            <Select.Option value={1}>In stock</Select.Option>
            <Select.Option value={2}>Not in stock</Select.Option>
            <Select.Option value={3}>Not marked</Select.Option>
          </Select>
        </div>

        {/* In-Stock audit: change modal (admin-only) */}
        <Modal
          title={
            "Change stock status" +
            (this.state.stockRecord ? " — " + this.state.stockRecord.splitOrderNumber : "")
          }
          visible={this.state.stockModalVisible}
          onCancel={this.closeStockModal}
          onOk={this.saveStockMark}
          okText="Save"
          confirmLoading={this.state.stockSaving}
          destroyOnClose
        >
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>Status</div>
            <Radio.Group
              value={this.state.stockNewValue}
              onChange={(e) => this.setState({ stockNewValue: e.target.value })}
            >
              <Radio.Button value={1}>In stock</Radio.Button>
              <Radio.Button value={0}>Not in stock</Radio.Button>
            </Radio.Group>
          </div>
          <div>
            <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>
              Remark <span style={{ color: "red" }}>*required</span>
            </div>
            <Input.TextArea
              rows={3}
              value={this.state.stockRemark}
              onChange={(e) => this.setState({ stockRemark: e.target.value })}
              placeholder="Why is this order in / not in stock? (required)"
            />
            <div style={{ fontSize: 11, color: "#888", marginTop: 6 }}>
              Saved with your name + timestamp automatically. Remark can’t be empty.
            </div>
          </div>
        </Modal>

        {/* In-Stock audit: history modal */}
        <Modal
          title={"Stock history" + (this.state.historySON ? " — " + this.state.historySON : "")}
          visible={this.state.historyVisible}
          onCancel={() => this.setState({ historyVisible: false })}
          footer={null}
          destroyOnClose
        >
          {this.state.historyRows && this.state.historyRows.length ? (
            <Timeline>
              {this.state.historyRows.map((h) => (
                <Timeline.Item key={h.stockAuditID} color={h.inStock === 1 ? "green" : "red"}>
                  <div style={{ fontSize: 12, color: "#888" }}>{h.markedOn}</div>
                  <b style={{ color: h.inStock === 1 ? "#12854a" : "#c62348" }}>
                    {h.inStock === 1 ? "Marked IN STOCK" : "Marked NOT IN STOCK"}
                  </b>
                  <div>“{h.remark}”</div>
                  <div style={{ fontSize: 12, color: "#888" }}>{h.markedByName}</div>
                </Timeline.Item>
              ))}
            </Timeline>
          ) : (
            <div style={{ color: "#888" }}>No history yet.</div>
          )}
        </Modal>

        <Table
          size="small"
          columns={this.columns}
          dataSource={filteredItems}
          pagination={this.state.pagination}
          loading={loading}
          rowSelection={{
            hideSelectAll: true,
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              this.setState({
                selectedOrderID:
                  selectedRows.length > 0
                    ? selectedRows[0].orderID.toString()
                    : null,
                // selectedOrdersOfCustomer:
                //   selectedRows.length > 0 ? selectedRows[0].customerId : null,
                // selectedBranch:
                //   selectedRows.length > 0
                //     ? selectedRows[0].storeID.toString()
                //     : null,
              });
              this.setState({
                selectedRowKeys: selectedRowKeys,
                selectedRows: selectedRows,
              });
            },
            getCheckboxProps: (record) => {
              let shouldDisable = false;
              if (record.performaNumber === null || record.invoiceStatus > 1) {
                shouldDisable = true;
              } else {
                // if (this.state.selectedOrdersOfCustomer === null) {
                if ([null].includes(this.state.selectedOrderID)) {
                  shouldDisable = false;
                } else if (
                  this.state.selectedOrderID === record.orderID.toString()
                  // this.state.selectedOrderID === record.customerId &&
                  // this.state.selectedBranch === record.storeID.toString()
                ) {
                  shouldDisable = false;
                } else {
                  shouldDisable = true;
                }
              }
              return { disabled: shouldDisable };
            },
          }}
          // expandable={{
          //   expandedRowRender: (record) => {
          //     return (
          //       <Descriptions>
          //         {record.deliveryDate !== "" &&
          //         record.deliveryDate !== null ? (
          //           <Descriptions.Item label={labels.DELIVERY_DATE}>
          //             {Moment(record.deliveryDate).format("YYYY-MM-DD")}
          //           </Descriptions.Item>
          //         ) : null}
          //         <Descriptions.Item label={labels.DELIVERY_TYPE}>
          //           {record.deliveryTypeName}
          //         </Descriptions.Item>
          //         <Descriptions.Item label={labels.PROFORMA_INVOICE_NUMBER}>
          //           {record.performaNumber}
          //         </Descriptions.Item>
          //         {[null, undefined, ""].includes(
          //           record.perfomaInvoiceDate
          //         ) ? null : (
          //           <Descriptions.Item label={labels.PROFORMA_INVOICE_DATE}>
          //             {Moment(record.perfomaInvoiceDate).format("YYYY-MM-DD")}
          //           </Descriptions.Item>
          //         )}
          //         {[null, undefined, ""].includes(record.invoiceDate) ? null : (
          //           <Descriptions.Item label={labels.INVOICE_DATE}>
          //             {Moment(record.invoiceDate).format("YYYY-MM-DD")}
          //           </Descriptions.Item>
          //         )}
          //         <Descriptions.Item label={labels.NO_OF_GARMENTS}>
          //           {record.noOfGarment}
          //         </Descriptions.Item>
          //       </Descriptions>
          //     );
          //   },
          // }}
          onChange={(pagination, filters, sorter, extra) => {
            this.setState(
              {
                sorter: {
                  ...sorter,
                  order:
                    sorter.order === "ascend"
                      ? "asc"
                      : sorter.order === "descend"
                      ? "desc"
                      : sorter.order,
                },
              },
              () => {
                this.fetchItems(
                  pagination.current,
                  pagination.pageSize,
                  this.state.sorter.field,
                  this.state.sorter.order,
                  this.state.search
                );
              }
            );
          }}
        />
      </div>
    );
  }
}

export default withRouter(Master);
